// src/logger.js
import { db } from "./firebase";
import { collection, addDoc, serverTimestamp } from "firebase/firestore";

export const logEvent = async (event, details) => {
  try {
    await addDoc(collection(db, "admin_logs"), {
      event: event,
      details: details,
      // serverTimestamp ব্যবহার করলে সার্ভারের সঠিক সময় পাওয়া যায়
      time: new Date().getTime(), 
      createdAt: serverTimestamp() 
    });
  } catch (error) {
    console.error("Logging failed:", error);
  }
};